
<script>
export default {
  template: '#vue-filters-panel-filter-list',
  delimiters: ['${', '}'],

  props: {
    facet: {
      type: Object
    }
  },

  data: function() {
    return {
      showingAll: false,
      maxItemsCollapsed: 3,
    }
  },

  computed: {
    isCollapsed() {
      return !this.showingAll && this.facet.FacetResults.length > (this.maxItemsCollapsed + 1);
    },

    items() {
      if(!this.isCollapsed) {
        return this.facet.FacetResults;
      }
      const items = [];
      for(let i = 0; i < Math.min(this.facet.FacetResults.length, this.maxItemsCollapsed); i += 1) {
        items.push(this.facet.FacetResults[i]);
      }
      return items;
    }
  },

  methods: {
    checkboxChanged() {
      this.$emit('clicked');
    }
  }

}
</script>
